// i18n area 'backups' — locale sk-SK (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.sk-SK.meta.json.
import type { enUS } from './backups'

export const skSK: typeof enUS = {
  ckpt: {
    contents: 'Prijíma',
    contentsHint:
      'Čo sem smie pristáť. „Checkpointy“ je konfigurácia klastra, „Zálohy dát“ sú zálohy virtuálnych strojov: obe čítania sa skladajú, jeden cieľ môže prijať oboje.',
    content: { checkpoints: 'Checkpointy', backups: 'Zálohy dát' },
    destinationsTitle: 'Ciele záloh',
    checkpointsTitle: 'Checkpointy',
    restoreTitle: 'Obnovenie',
    addDestination: 'Pridať cieľ',
    addDestinationTitle: 'Pridať cieľ záloh',
    editDestinationTitle: 'Upraviť cieľ',
    storage: 'Úložisko',
    storageHint: 'Úložisko typu dir (dir/NFS/CIFS/CephFS) — artefakty sú obyčajné súbory pod namespace platformy.',
    schedule: 'Plánovanie',
    scheduleNone: 'Len ručne',
    scheduleHourly: 'Každú hodinu',
    scheduleDaily: 'Denne',
    scheduleWeekly: 'Týždenne',
    scheduleHour: 'Hodina',
    scheduleWeekday: 'Deň',
    scheduleHint:
      'Plánované checkpointy nemajú operátora, ktorý by zadal masterpass: tajomstvá z keystore sa zabalia ako placeholdery.',
    retention: 'Uchovávanie',
    retentionHint:
      'Koľko plánovaných checkpointov ponechať — sweeper odstraňuje najstaršie nad rámec počtu. Ručné checkpointy a checkpointy pred obnovením sa neodstraňujú nikdy.',
    paused: 'Pozastavené',
    pausedHint:
      'Blackout operátora: kým pauza trvá, na tomto cieli sa nič neplánuje a nič neprerezáva — dátové policy aj checkpointy rovnako. Bežiacich behov sa nikdy nedotýka.',
    orphanRuns: '{n} osirotených behov',
    orphanRunsHint:
      'Plánované behy policy, ktoré na tomto cieli už neexistujú: žiadna retencia ich neriadi — nikdy sa nepočítajú ani neorezávajú — a maže ich len ruka. Šošovka „backups“ v tvirt diagnose menuje odstránené policy.',
    rescan: 'Znovu prijať artefakty',
    rescanTitle: 'Opätovné prijatie artefaktov {name}',
    rescanHint:
      'Znovu zostaví katalóg záloh (VM/CT/App) z manifestov artefaktov prítomných v cieli. Existujúce riadky sa nikdy nemenia; zálohy neznámych politík ostávajú siroty (nikdy sa automaticky neorezávajú). Krok po bootstrap obnove.',
    masterpassDrWarning:
      'Scenár katastrofy: disky LUKS sa vrátia IBA z checkpointu S masterpass. Plánované checkpointy balia zástupné hodnoty — pravidelne robte ručný checkpoint s masterpass.',
    policy: {
      title: 'Policy záloh dát',
      hint: 'Pomenované policy: ktoré objekty (kind, značky, scope), ako často, kedy smie beh začať a koľko kópií držať. Gesto zápisu ostáva vlastníkovi objektu: značky sa prideľujú na jeho vlastnom scope.',
      add: 'Pridať policy',
      column: 'Dátové policy',
      name: 'Názov',
      nameHint:
        'Štítok policy, jedinečný v rámci cieľa. Behy sledujú stabilné id policy: premenovanie je zadarmo; vymazanie osirotí jej behy (už sa nepočítajú ani neorezávajú).',
      kindLocked: 'Rodinu objektov existujúcej policy nemožno zmeniť: vytvorte novú policy.',
      kindLabel: 'Objekty',
      kind: { vm: 'Virtuálne stroje', ct: 'Kontajnery', app: 'Aplikácie' },
      tags: 'Selektor značiek',
      tagsHint:
        'Dvojice tag=hodnota oddelené čiarkami, spojené AND. Prázdne značky a scope nevyberajú nič — nikdy „všetko“.',
      scopes: 'Scope',
      scopesHint: 'Cesty scope (podstromy), oddelené čiarkami, medzi sebou v OR.',
      windowStart: 'Okno od',
      windowEnd: 'Okno do',
      windowHint:
        'Okno vykonávania (HH:MM, miestny čas; začiatok za koncom prekračuje polnoc). Riadi len ŠTART: beh, ktorý ho pretiahne, sa nikdy nezabíja.',
      mode: 'Režim',
      modeHint: 'Inkrementálny ide na rodine sérií; pretrhnutá séria degraduje na full, povedané v denníku.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementálny',
      requireQuiesce: 'Vyžadovať quiesce (guest agent)',
      paused: 'Policy pozastavená',
      retentionNone: 'Držať všetko',
      retentionCount: 'Počet',
      retentionGfs: 'Kruhy GFS',
      gfs: { keepLast: 'Posledné', daily: 'Denné', weekly: 'Týždenné', monthly: 'Mesačné', yearly: 'Ročné' },
      gfsHint:
        'Pre každý kruh sa drží najnovšia záloha z každého z posledných N období. Držaná záloha udržiava nažive celú svoju reťaz — nikdy základ so sirotami.',
      lastRun: 'Posledný beh',
      neverRan: 'nikdy nebežalo'
    },
    lastCheckpoint: 'Posledný checkpoint',
    neverRun: 'Nikdy nevytvorené',
    createNow: 'Vytvoriť checkpoint',
    createNowTitle: 'Vytvoriť checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Chráni tajné hodnoty keystore (argon2id → AES-256-GCM, po hodnotách). Nikdy sa neukladá: uschovajte si ju — bez nej obnovenie vytvorí placeholdery namiesto skutočných tajomstiev.',
    masterpassEmptyHint: 'Nechajte prázdne, ak sa majú namiesto tajomstiev zabaliť explicitné placeholdery.',
    createStarted: 'Checkpoint prebieha…',
    destinationInUseError: '„{name}“ stále obsahuje checkpointy — najprv ich odstráňte.',
    origin: 'Pôvod',
    originManual: 'ručný',
    originSchedule: 'plánovaný',
    originPreRestore: 'pred obnovením',
    originPreChange: 'pred zmenou',
    preChangeRetention: 'Checkpointy pred zmenou',
    preChangeRetentionHint:
      'Prázdne = vypnuté. Prvý zápis konfigurácie po období pokoja tu zmrazí predchádzajúci stav (pôvod „pred zmenou“); najnovšie sa uchovávajú do počtu — vlastná, prerezávaná retencia.',
    diffTitle: 'Náhľad zmien',
    diffFailed: 'Náhľad zlyhal',
    diffRetry: 'Skúsiť znova',
    diffCounts: '{changed} na zmenu · {missing} na vytvorenie · {extra} navyše · {equal} zhodných',
    diffChanged: 'mení sa',
    diffMissing: 'bol by vytvorený',
    diffExtra: 'bol by zmazaný',
    diffJsonb: 'jsonb referencie nemožno overiť pred aplikáciou',
    diffSecret: 'zapečatené polia, neporovnateľné',
    diffMore: 'ďalších {n}…',
    diffNeeded: 'Štart sa odistí, keď náhľad zodpovedá výberu.',
    phase: 'Stav',
    phaseRunning: 'prebieha',
    phaseComplete: 'dokončený',
    phaseError: 'chyba',
    secrets: 'Tajomstvá',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholdery',
    size: 'Veľkosť',
    created: 'Vytvorené',
    destination: 'Cieľ',
    download: 'Stiahnuť .tvbk',
    deleteCheckpoint: 'Odstrániť checkpoint',
    noCheckpoints: 'Žiadne checkpointy — vytvorte prvý z niektorého cieľa.',

    // Round #156 (dialog standard): la superficie di lettura completa del
    // record di archivio — righe di dettaglio per i campi mai mostrati in tabella.
    families: 'Rodiny',
    generation: 'Generácia',
    completedAt: 'Dokončené',
    errorDetail: 'Detail chyby',
    manifest: 'Manifest',
    restoreHint: 'Nahrajte artefakt .tvbk: prieskumník ukáže, čo obsahuje, potom si vyberiete, čo obnoviť a ako.',
    uploadFile: 'Nahrať súbor .tvbk',
    uploading: 'Nahrávanie…',
    uploadFailed: 'Artefakt sa nepodarilo otvoriť',
    explorerTitle: 'Obsah checkpointu',
    checkpointFrom: 'Checkpoint klastra {cluster}, vytvorený {when} ({origin}, generácia {generation})',
    otherCluster:
      'Tento checkpoint pochádza z INÉHO klastra ({cluster}) — obnovenie medzi klastrami príde v budúcom rounde.',
    encrypted: 'šifrovaný',
    objectsCount: 'objekty: {n}',
    mode: 'Režim',
    modeMerge: 'Merge — zosúlaďuje: upsert vybraných, nič nemaže',
    modeOverwrite:
      'Overwrite — vyhráva checkpoint: celá vybraná rodina sa nahradí vcelku (aktuálne riadky, ktoré v checkpointe chýbajú, zaniknú)',
    restoreMasterpassHint:
      'Masterpass, s ktorou bol checkpoint vytvorený. Bez nej sa šifrované tajomstvá obnovia ako explicitné placeholdery.',
    checkMasterpass: 'Overiť',
    masterpassOk: 'Masterpass je správna',
    masterpassWrong: 'Nesprávna masterpass',
    parachuteDestination: 'Padákový cieľ',
    parachuteHint: 'Skôr než sa dotkne akéhokoľvek riadku, úloha tu vytvorí automatický checkpoint pred obnovením.',
    summaryTitle: 'Čo sa stane',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'celá rodina',
    summaryObjects: 'vybrané objekty: {n}',
    confirmHint: 'Na potvrdenie napíšte názov klastra ({name}) — obnovenie prepisuje deklarovanú konfiguráciu.',
    confirmField: 'Názov klastra',
    startRestore: 'Obnoviť',
    restoreRunning: 'Obnovenie prebieha…',
    restoreDone: 'Obnovenie dokončené — reconcilery konvergujú na novú deklaráciu.',
    restoreFailed: 'Obnovenie zlyhalo',
    discard: 'Zahodiť',
    selectionEmpty: 'Vyberte aspoň jednu rodinu alebo objekt.'
  },

  backup: {
    intro: {
      title: 'Zálohovanie dát VM a kontajnerov',
      subtitle: 'Stavebné kamene, ktoré používa externý zálohovací softvér',
      whatItIs:
        'TVirt vystavuje štyri primitívy: quiesced snímky, sledovanie zmien pre každý disk, NBD export iba na čítanie a export konfigurácie. Riadia ich Veeam, Bacula, Acronis a spol.',
      whatItIsNot:
        'TVirt nie je zálohovací produkt: nič neplánuje, neriadi uchovávanie a nedrží žiadny archív vašich dát. Uchovávanie, katalógy a politiky obnovenia zostávajú na softvéri, ktorý už používate.'
    },
    cbt: {
      title: 'Sledovanie zmien',
      colVm: 'VM',
      colDisk: 'Disk',
      colState: 'Stav',
      colBitmaps: 'Bitmapy',
      colObservedAt: 'Pozorované',
      colChangeId: 'Change ID',
      colMechanic: 'Mechanizmus',
      stateActive: 'Aktívne',
      stateInactive: 'Vypnuté',
      stateInconsistent: 'Nekonzistentné — ďalšia záloha musí byť plná',
      stateBroken: 'Reťaz prerušená — vypnite a zapnite ako novú reťaz',
      stateSnapshots: 'Vždy zapnuté — delta medzi snapshotmi',
      stateUnavailable: 'Na tomto disku nedostupné',
      mechanic: {
        'qcow2-bitmap': 'Bitmapa qcow2',
        'rbd-snapdiff': 'Diff snapshotov Ceph',
        'lvm-thin-delta': 'Delta thin poolu',
        none: 'Žiadny'
      },
      empty:
        'Žiadny disk VM. Sledovanie zmien sa číta po diskoch: zapnite ho na disku qcow2 alebo robte snapshoty na rbd/SAN.',
      chainBroken: 'Reťaz prerušená',
      chainBrokenText:
        'Prerušená udalosťou {reason}: {bitmaps}. Vypnite bitmapu (reťaz je stratená, ďalšia záloha je plná) a zapnite ju ako novú reťaz.',
      lineages: 'Epochy',
      epochFrozen: 'zmrazená v snapshote {snapshot}',
      epochLost: 'stratená ({cause})',
      epochRecording: 'zaznamenáva na hlave',
      milestones: 'Míľniky (snapshoty)',
      enable: 'Zapnúť sledovanie zmien',
      disable: 'Vypnúť',
      reset: 'Resetovať',
      changedAreas: 'Zmenené oblasti',
      denied: 'Chýba vám oprávnenie na túto VM',
      enableTitle: 'Zapnúť sledovanie zmien',
      disableTitle: 'Vypnúť sledovanie zmien',
      resetTitle: 'Resetovať bitmapu',
      areasTitle: 'Zmenené oblasti',
      bitmapName: 'Názov bitmapy',
      bitmapNameHint: 'Vlastný názov: tvirt- a tvbk- patria platforme',
      granularity: 'Granularita (bajty)',
      granularityHint: 'Mocnina dvoch; predvolene 65536',
      bitmap: 'Bitmapa',
      disableHint: 'Odstráni bitmapu aj celú históriu jej epoch: ďalšia záloha musí byť plná.',
      resetHint: 'Vyprázdni bitmapu — nová základňa: change ID staršie ako reset sa už nedá zložiť.',
      areasFrom: 'Od snapshotu',
      areasTo: 'Po snapshot',
      areasRun: 'Vypočítať',
      areasResult: '{count} zmenených oblastí, {bytes}',
      areasEmpty: 'Medzi oboma snapshotmi nie je žiadna zmenená oblasť',
      areasZero: 'nuly',
      areasMore: 'zobrazených prvých {shown} z {count}',
      submit: 'Potvrdiť',
      error: 'Akcia sledovania zmien zlyhala'
    },
    exports: {
      title: 'Otvorené exporty NBD',
      colVm: 'VM',
      colDisk: 'Disk',
      colSnapshot: 'Snapshot',
      colBitmap: 'Bitmapa',
      colPhase: 'Fáza',
      colNode: 'Uzol',
      colEndpoint: 'Endpoint',
      colExpires: 'Vyprší',
      colCreated: 'Otvorené',
      colError: 'Chyba',
      phase: {
        preparing: 'Pripravuje sa',
        ready: 'Pripravený',
        closed: 'Zatvorený',
        error: 'Zlyhal'
      },
      expiresIn: 'o {minutes} min',
      expired: 'vypršal',
      empty: 'Žiadny export. Relácia čítania poskytuje jeden disk v jednom snapshote klientovi NBD; relácia zápisu plní panenský disk zastaveného VM. Obe zomierajú pri vypršaní.',
      endpointHint: 'TLS s CA klastra; názov exportu je lístok — zaniká so sedením',
      closeDenied: 'Chýba vám oprávnenie zatvárať exporty tejto VM',
      open: 'Otvoriť export NBD',
      openTitle: 'Otvoriť export NBD',
      openDisk: 'Disk',
      openBitmap: 'Bitmapa (voliteľné)',
      openBitmapHint:
        'Zverejní epochu tejto bitmapy zmrazenú v tomto snapshote ako meta-context zmenených extentov (iba disky qcow2)',
      openTtl: 'Životnosť (minúty)',
      openSubmit: 'Otvoriť',
      openError: 'Export sa nepodarilo otvoriť',
      colMode: 'Režim',
      mode: {
        read: 'Čítanie',
        write: 'Zápis'
      },
      caCertificate: 'CA klastra',
      caCopy: 'Kopírovať PEM',
      caDownload: 'Stiahnuť ca-cert.pem',
      caHint: 'Zapíšte PEM do ca-cert.pem v súkromnom adresári a pripojte sa cez nbds://…?tls-certificates=<adresár> (nbdcopy, nbdinfo) alebo --object tls-creds-x509,dir=<adresár>,endpoint=client (qemu-img)',
      caAbsent: 'Relácia nenesie CA (žiadna PKI)',
      openWrite: 'Otvoriť export na zápis',
      openWriteTitle: 'Otvoriť export na zápis',
      openWriteIntro: 'Disk musí byť panenský: zrodený prázdny, nikdy nezapísaný, bez snapshotu; VM zastavené. Obnova disk PLNÍ, neopravuje ho. Kým je relácia otvorená, VM sa nespustí, neurobí snapshot, neklonuje sa a disk sa nepresunie.',
      openWriteSubmit: 'Otvoriť',
      openWriteError: 'Export na zápis sa nepodarilo otvoriť',
      openWriteDenied: 'Chýba vám vm.restore.data na tomto VM',
      openWriteStopped: 'Zastavte VM, aby ste otvorili export na zápis',
      fromDescription: 'Vytvoriť VM z popisu',
      fromDescriptionTitle: 'Vytvoriť VM z popisu',
      fromDescriptionIntro: 'Popis z export-vm-meta sa vracia ako zastavené VM s prázdnymi diskami opísanej geometrie — pripravené na exporty na zápis, disk po disku. Bajty tadiaľto neprechádzajú: nesie ich restore-disk (CLI) alebo klient NBD zálohovacieho produktu.',
      fromDescriptionDoc: 'Popis (JSON)',
      fromDescriptionDocHint: 'Vložte dokument z export-vm-meta alebo vyberte súbor',
      fromDescriptionFile: 'Vybrať súbor…',
      fromDescriptionInvalid: 'Text nie je dokument JSON',
      fromDescriptionName: 'Názov nového VM',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Váš domovský scope',
      fromDescriptionStorage: 'Úložisko diskov',
      fromDescriptionStorageHint: 'Každý disk sa rodí tu, v predvolenom formáte úložiska',
      fromDescriptionMetadataStorage: 'Úložisko metadát',
      fromDescriptionSameAsStorage: 'Rovnaké ako disky',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Bez bridge ani siete sa VM rodí bez kariet',
      fromDescriptionNetwork: 'Logická sieť (fabric/sieť)',
      fromDescriptionSubmit: 'Vytvoriť',
      fromDescriptionError: 'VM sa nepodarilo vytvoriť',
      fromDescriptionDone: 'VM vytvorené: {name}',
      fromDescriptionOpen: 'Otvoriť VM',
      fromDescriptionDenied: 'Chýba vám vm.create',
      fromDescriptionStillRunning: 'Vytváranie stále beží: čaká sa ďalej'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Zálohy dát virtuálnych strojov',
      titleOnVm: 'Zálohy dát',
      empty: 'Žiadna záloha. Záloha prenesie disky, varstore UEFI a stav vTPM na cieľ a prežije virtuálny stroj.',
      colVm: 'VM',
      colCreated: 'Vyhotovená',
      colPhase: 'Výsledok',
      colDestination: 'Cieľ',
      colContains: 'Obsah',
      colSize: 'Veľkosť',
      colOrigin: 'Pôvod',
      colMode: 'Typ',
      retentionChip: 'Retencia',
      retentionHint:
        'Retencia cieľa môže túto zálohu zmazať bez opýtania: zrodila sa z plánu. Ručné zálohy sa nikdy nezametajú.',
      policyRemoved: 'Policy odstránená: {name}',
      policyRemovedHint:
        'Policy, ktorá tento backup naplánovala, už neexistuje: žiadna retencia ho neriadi (nikdy sa neorezáva automaticky) — vymažte ho ručne, keď už nebude potrebný.',
      phase: {
        running: 'Prebieha',
        complete: 'Dokončená',
        error: 'Zlyhala'
      },
      origin: {
        manual: 'Ručná',
        schedule: 'Plánovaná'
      },
      mode: {
        full: 'Plná',
        incremental: 'Prírastková'
      },
      contains: {
        disks: 'Disky',
        varstore: 'Varstore UEFI',
        vtpm: 'Stav vTPM',
        snapshots: 'Snímky'
      },
      vmState: {
        stopped: 'VM vypnutý',
        running: 'VM beží (za behu)'
      },
      artifactClass: { metadata: 'Metadáta', data: 'Dáta', secret: 'Tajomstvo' },
      detail: {
        tabOverview: 'Prehľad',
        tabArtefact: 'Artefakt',
        id: 'Identifikátor',
        scope: 'Rozsah',
        vmState: 'Stav VM pri kopírovaní',
        pointInTime: 'Okamih dát',
        completedAt: 'Ukončená',
        node: 'Uzol, ktorý kopíroval',
        error: 'Chyba',
        path: 'Adresár na úložisku',
        checksum: 'sha256 manifestu',
        secretsExposed: 'Citlivý materiál v otvorenej podobe',
        secretsExposedYes: 'Áno — cieľ nešifruje',
        secretsExposedNo: 'Nie',
        baseBackup: 'Základná záloha',
        tabManifest: 'Manifest',
        manifestHint:
          'Otvorený index artefaktu: jeden súbor na riadok so svojím sha256. Adresár sa dá overiť aj bez TVirt — stačia qemu-img, tar a jq.',
        manifestEmpty: 'Manifest neuvádza žiadne súbory.',
        manifestError: 'Manifest sa nedá prečítať',
        colEntry: 'Súbor',
        colClass: 'Trieda',
        colSha: 'sha256'
      },
      create: {
        action: 'Zálohovať teraz',
        title: 'Zálohovať teraz',
        submit: 'Spustiť zálohu',
        destination: 'Cieľ',
        destinationHint: 'Len ciele, ktoré prijímajú zálohy.',
        noDestinations: 'Žiadny cieľ neprijíma zálohy: vytvorte ho v Systém → Checkpointy.',
        contentsHint:
          'Cestujú všetky disky, varstore UEFI a stav vTPM. Tie posledné dva sú podstata: zapečatený hosť musí znova naštartovať.',
        error: 'Záloha sa nerozbehla',
        stillRunning: 'Záloha stále beží — kopírovanie pokračuje, aj keď zavriete.',
        vmRunning:
          'Virtuálny stroj je {phase}: záloha potrebuje ustálený VM — vypnutý pre studenú kópiu, bežiaci pre kópiu za behu.'
      },
      restore: {
        action: 'Obnoviť',
        title: 'Obnoviť',
        intro: 'Obnova je nezvratná. Zvoľte, kam sa dáta vrátia: do nového stroja, alebo cez ten pôvodný.',
        modeNewVm: 'Obnoviť do NOVÉHO virtuálneho stroja',
        modeNewVmHint:
          'Nesiaha na nič, čo existuje — touto voľbou sa záloha overuje. Nový identifikátor a čerstvo razené adresy MAC.',
        modeOver: 'Prepísať pôvodný virtuálny stroj',
        modeOverHint: 'Zničí súčasné dáta cieľového stroja, bez cesty späť. Virtuálny stroj musí byť vypnutý.',
        newName: 'Názov nového stroja',
        newNameHint: 'Musí byť voľný v cieľovom rozsahu.',
        storage: 'Úložisko pre disky',
        storageHint: 'Povinné: manifest zaznamenáva veľkosť a formát disku, nikdy úložisko, na ktorom ležal.',
        metadataStorage: 'Úložisko pre varstore a vTPM',
        metadataStorageHint: 'Kam dopadnú identita UEFI a stav vTPM.',
        sameAsStorage: 'Rovnaké ako disky',
        bridge: 'Bridge hostiteľa',
        bridgeHint:
          'Každá zaznamenaná sieťová karta sa vráti na tomto bridge s novou MAC. Ponechané prázdne, stroj sa narodí bez kariet — bezpečnejšia predvoľba.',
        overwriteTitle: 'Chystáte sa prepísať tento virtuálny stroj',
        overwriteName: 'Názov',
        overwriteId: 'Identifikátor',
        overwriteDisks: 'Disky, ktoré budú prepísané',
        overwriteNoDisks: 'Žiadne disky.',
        overwriteKeeps:
          'Nedotknuté zostávajú identifikátor, názov, rozsah, sieťové karty a adresy MAC: záloha sú DÁTA, konfigurácia je checkpoint.',
        confirmField: 'Názov stroja',
        confirmHint: 'Napíšte {name} na potvrdenie.',
        targetLoading: 'Načítava sa cieľový stroj…',
        targetRunning: 'Cieľový stroj je {phase}: obnova prepisuje bajty pod hosťom, preto ho chce vypnutý.',
        targetGone: 'Pôvodný stroj sa už nedá prečítať: zostáva obnova do nového stroja.',
        onlyComplete: 'Záloha je {phase}: obnoviť môže len dokončená záloha.',
        submitNewVm: 'Obnoviť do nového stroja',
        submitOver: 'Prepísať',
        error: 'Obnova sa nerozbehla',
        stillRunning: 'Obnova stále beží — kopírovanie celých diskov zaberie čas.'
      }
    },
    guest: {
      title: {
        ct: 'Zálohy dát kontajnerov',
        app: 'Zálohy dát App'
      },
      tabTitle: 'Zálohy',
      empty: 'Žiadne zálohy. Záloha kopíruje perzistentné dáta na cieľ a prežije svoj objekt.',
      colSubject: {
        ct: 'Kontajner',
        app: 'App'
      },
      colCreated: 'Vytvorená',
      colPhase: 'Výsledok',
      colDestination: 'Cieľ',
      colContains: 'Obsah',
      colSize: 'Veľkosť',
      colOrigin: 'Pôvod',
      policyRemoved: 'Policy odstránená: {name}',
      policyRemovedHint:
        'Policy, ktorá tento backup naplánovala, už neexistuje: žiadna retencia ho neriadi (nikdy sa neorezáva automaticky) — vymažte ho ručne, keď už nebude potrebný.',
      phase: {
        running: 'Prebieha',
        complete: 'Dokončená',
        error: 'Zlyhala'
      },
      origin: {
        manual: 'Ručná',
        schedule: 'Plánovaná'
      },
      state: {
        stopped: 'Objekt zastavený',
        running: 'Objekt beží (zmrazený)'
      },
      contains: {
        rootfs: 'Strom rootfs',
        config: 'Konfigurácia',
        volumes: 'Perzistentné zväzky',
        root: 'Perzistentný root'
      },
      artifactClass: {
        metadata: 'Metadáta',
        data: 'Dáta',
        secret: 'Tajné'
      },
      create: {
        action: 'Zálohovať teraz',
        title: 'Nová záloha',
        submit: 'Spustiť zálohu',
        error: 'Záloha sa nespustila',
        destination: 'Cieľ',
        destinationHint: 'Len ciele, ktoré prijímajú zálohy dát.',
        noDestinations: 'Žiadny cieľ neprijíma zálohy dát: pridajte cieľu „Zálohy dát“.',
        hint: {
          ct: 'Cestuje celý strom rootfs, verne (číselní vlastníci, xattrs, ACL), plus deklarovaná konfigurácia v manifeste. Bežiaci kontajner je počas balenia ZMRAZENÝ: crash-consistent kópia, deklarovaná.',
          app: 'Cestujú LEN perzistentné zväzky (a perzistentný root), plus konfigurácia v manifeste. Efemérne časti sú ratifikáciou vylúčené a manifest ich menuje; env hodnoty deklarované ako tajné necestujú.'
        },
        stillRunning: 'Záloha stále beží — balenie celých stromov chvíľu trvá.'
      },
      detail: {
        tabOverview: 'Prehľad',
        tabManifest: 'Manifest',
        id: 'Identifikátor',
        scope: 'Rozsah',
        state: 'Stav pri kópii',
        pointInTime: 'Dáta k okamihu',
        completedAt: 'Dokončené',
        node: 'Uzol, ktorý kopíroval',
        error: 'Chyba',
        path: 'Adresár na úložisku',
        checksum: 'sha256 manifestu',
        manifestHint:
          'Index artefaktu: jeden záznam na súbor s jeho sha256 — bez hashov je „záloha tam je“ aktom viery.',
        manifestError: 'Manifest sa nedá prečítať',
        manifestEmpty: 'Žiadne artefakty v manifeste.',
        colEntry: 'Súbor',
        colClass: 'Trieda',
        colSha: 'sha256',
        excluded: 'Vylúčené ratifikáciou (necestuje)',
        secretKeys: 'Vynechané tajné env kľúče (#307) — po obnove ich zadajte znova'
      },
      restore: {
        action: 'Obnoviť',
        title: 'Obnova',
        submit: 'Obnoviť',
        error: 'Obnova sa nespustila',
        stillRunning: 'Obnova stále beží — rozbaľovanie celých stromov chvíľu trvá.',
        onlyComplete: 'Záloha je {phase}: obnoviť môže len dokončená záloha.',
        asNew: {
          ct: 'Do NOVÉHO kontajnera — nič neničí: gesto, ktorým sa záloha overuje',
          app: 'Do NOVEJ App — nič neničí: gesto, ktorým sa záloha overuje'
        },
        over: {
          ct: 'CEZ zdrojový kontajner — celý strom rootfs sa nahradí',
          app: 'CEZ zdrojovú App — obsah každého perzistentného zväzku sa nahradí'
        },
        name: 'Názov nového objektu',
        storage: 'Úložisko',
        storageHint: 'Kam obnovené dáta pristanú — manifest nikdy nezaznamenáva stratený pool.',
        storageDeclared: 'Úložiská deklarované v manifeste',
        bridge: 'Bridge hostiteľa',
        bridgeHint:
          'Každá zaznamenaná karta sa vráti na tento bridge s čerstvou MAC. Prázdne = rodí sa nepripojený, najbezpečnejšie predvolené.',
        node: 'Uzol',
        nodeHint: 'Člen, na ktorom sa App znovu zrodí: uzol je identita klastra a nikdy nepochádza z manifestu.',
        secretKeysWarning:
          'Env hodnoty deklarované ako tajné v zálohe necestujú: znovuzrodená kópia ich chce zadané znova (log úlohy menuje kľúče).',
        overInventory: 'Chystáte sa prepísať tento objekt',
        confirmType: 'Napíšte {name} na potvrdenie',
        targetGone: 'Zdrojový objekt sa už nedá prečítať: ostáva obnova ako nový.',
        targetLoading: 'Čítanie cieľového objektu…',
        targetRunning: 'Cieľový objekt beží: obnova nahrádza bajty pod hosťom, chce ho teda zastavený.'
      }
    }
  }
}
